export const FIND_RESULT_RATING_REQUEST = 'FIND_RESULT_RATING_REQUEST';

export const findResultRatingRequest = ( id ) => ({
    type: FIND_RESULT_RATING_REQUEST,
    payload: { id }
});
